import { useState } from "react";
import { useRecordContext, useResourceContext, useGetOne } from "react-admin";
import { format } from "date-fns";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const TimestampsPreviewField = ({ source }) => {
  const record = useRecordContext();
  const resource = useResourceContext();
  const [open, setOpen] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);

  const { data, isLoading } = useGetOne(resource, { id: record?.id }, { enabled: shouldFetch });

  if (!record) return <span>-</span>;

  const handleOpen = () => {
    setOpen(true);
    setShouldFetch(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShouldFetch(false);
  };

  const trycatchFormat = (a, b) => {
    try {
      return format(new Date(a * 1000), b)
    } catch (e) {
      return "Invalid Date"
    }
  }

  const timestamps = Array.isArray(data?.[source]) ? data[source] : [];

  const chartData = timestamps
    .sort((a, b) => a - b)
    .map((ts, index) => ({
      index,
      label: trycatchFormat(ts, "dd/MM HH:mm"),
      value: 1, // Valeur fictive juste pour voir la distribution
      ts,
    }));

  return (
    <>
      <Box display="flex" alignItems="center" gap={1}>
        <Button variant="text" size="small" onClick={handleOpen}>
          See all
        </Button>
      </Box>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>History</DialogTitle>
        <DialogContent dividers>
          {isLoading ? (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          ) : timestamps.length === 0 ? (
            <Typography>Empty</Typography>
          ) : (
            <>
              {/* <Box mb={2}>
                {timestamps
                  .sort((a, b) => b - a)
                  .map((ts, idx) => (
                    <Typography key={idx}>
                      {format(new Date(ts * 1000), "dd/MM/yyyy HH:mm")}
                    </Typography>
                  ))}
              </Box> */}

              <Box height={250}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={chartData}>
                    <XAxis dataKey="label" angle={-20} textAnchor="end" height={60} />
                    <YAxis hide />
                    <Tooltip
                      labelFormatter={(label, payload) =>
                        `Date : ${trycatchFormat(payload?.[0]?.payload?.ts, "dd/MM/yyyy HH:mm")}`
                      }
                    />
                    <Line type="monotone" dataKey="value" stroke="#8884d8" dot />
                  </LineChart>
                </ResponsiveContainer>
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TimestampsPreviewField;
